import { render, staticRenderFns } from "./TheEventSchedule.vue?vue&type=template&id=0a67a02a&scoped=true"
import script from "./TheEventSchedule.vue?vue&type=script&lang=js"
export * from "./TheEventSchedule.vue?vue&type=script&lang=js"
import style0 from "./TheEventSchedule.vue?vue&type=style&index=0&id=0a67a02a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a67a02a",
  null
  
)

export default component.exports